import moment from 'moment'
import * as React from 'react'
import I18n from 'core/i18n'
import styled from 'styled-components'
import * as constants from 'static/constants'
import { Button, Select } from 'components/atoms'
import SmallDateRangePickerCustomStyle from 'static/smallDateRangePickerCustomStyle'
import { DateRangePicker } from 'react-dates'
import { TypeFilter } from 'components/atoms'
import Typography from 'components/atoms/_layouts/Typography'

interface IProps {
  statuses: any
  searchParams: any
}

const ORDER_BY_OPTIONS = [
  { label: 'ツアー日時 昇順', value: 'order_by_tour_day_asc' },
  { label: 'ツアー日時 降順', value: 'order_by_tour_day_desc' },
  { label: '作成日時 昇順', value: 'order_by_created_at_asc' },
  { label: '作成日時 降順', value: 'order_by_created_at_desc' },
]

export const IndexFilter: React.FC<IProps> = props => {
  const [isFilterPanelOpen, setIsFilterPanelOpen] = React.useState(false)
  const [selectedStatuses, setSelectedStatuses] = React.useState(props.searchParams.statuses || [])
  const [startDate, setStartDate] = React.useState<moment.Moment>(
    props.searchParams.start_date ? moment(props.searchParams.start_date) : undefined
  )
  const [endDate, setEndDate] = React.useState<moment.Moment>(
    props.searchParams.end_date ? moment(props.searchParams.end_date) : undefined
  )
  const [focusedInput, setFocusedInput] = React.useState(null)
  const [orderBy, setOrderBy] = React.useState(props.searchParams.order_by)
  const isFirstRender = React.useRef(true)

  const handleCalendarOutSideRange = React.useCallback((calendarMoment: moment.Moment) => {
    return calendarMoment.isAfter(moment(), 'day')
  }, [])

  const onDateRangePickerChange = (dates: {
    startDate: moment.Moment | null
    endDate: moment.Moment | null
  }) => {
    setStartDate(dates.startDate)
    setEndDate(dates.endDate)
  }

  const changeFocusedInput = (changedFocusedInput: any) => {
    setFocusedInput(changedFocusedInput)
  }

  const applyFilter = React.useCallback(() => {
    const newURLParam = new URLSearchParams()
    if (!!startDate) {
      newURLParam.set('start_date', startDate.format(constants.DATE_FORMAT))
    }
    if (!!endDate) {
      newURLParam.set('end_date', endDate.format(constants.DATE_FORMAT))
    }
    newURLParam.set('order_by', orderBy)
    selectedStatuses.map(selectedStatus => {
      newURLParam.append('statuses[]', selectedStatus)
    })

    location.href = `/agent/trouble_reports?${newURLParam.toString()}`
  }, [startDate, endDate, selectedStatuses, orderBy])

  const clearFilter = React.useCallback(() => {
    location.href = `/agent/trouble_reports?order_by=${orderBy}`
  }, [orderBy])

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (!focusedInput) {
      applyFilter()
    }
  }, [orderBy, focusedInput, selectedStatuses])

  return (
    <Wrapper>
      <div>
        <Typography type="subtitle">ツアー開始日</Typography>
        <SmallDateRangePickerCustomStyle />
        <DateRangePicker
          startDate={startDate}
          startDateId="start_date"
          endDate={endDate}
          endDateId="end_date"
          onDatesChange={onDateRangePickerChange}
          focusedInput={focusedInput}
          onFocusChange={(currentFocusedInput: string | null) =>
            changeFocusedInput(currentFocusedInput)
          }
          numberOfMonths={1}
          isOutsideRange={handleCalendarOutSideRange}
          hideKeyboardShortcutsPanel={true}
          displayFormat={constants.DATE_FORMAT}
          minimumNights={0}
        />
      </div>
      <TypeFilter
        className="status_filter"
        name="ステータス"
        field="statuses"
        setIsFilterPanelOpen={setIsFilterPanelOpen}
        handleOnSubmit={({ statuses }) => setSelectedStatuses(statuses)}
        types={Object.keys(props.statuses).map(k => {
          return { id: k, name: props.statuses[k] }
        })}
      />
      <Button small={true} handleClick={clearFilter}>
        {I18n.t('generic.clear')}
      </Button>
      <div className="orderBy">
        <Select
          name="order_by"
          options={ORDER_BY_OPTIONS}
          defaultValue={props.searchParams.order_by ?? 'order_by_tour_day_desc'}
          onChangeHandler={e => setOrderBy(e.target.value)}
        />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .orderBy {
    margin-left: auto;
  }

  .Filter_Label {
    font-size: 12px;
  }
`
